import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The token-named sizes of web/src/styles/index.css (`--spacing-touch`, `--spacing-row`, `--spacing-nav-row`,
 * `--spacing-table-head`). tailwind-merge only knows the stock scale, so without this `cn('h-touch', 'h-8')`
 * kept both classes and the first one in the stylesheet won: a `compact` search box stayed 44px tall.
 */
const TOKEN_SIZES = ['touch', 'row', 'nav-row', 'table-head'];
const twMerge = extendTailwindMerge({
  extend: { classGroups: { h: [{ h: TOKEN_SIZES }], 'min-h': [{ 'min-h': TOKEN_SIZES }], w: [{ w: ['rail', ...TOKEN_SIZES] }], size: [{ size: TOKEN_SIZES }] } },
});

/** The shadcn/ui class helper: merge conditional classes and let the last Tailwind utility win. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
